import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMarketSummary } from './models';
import { Exchange } from '@cmctechnology/webinvest-constants';

export const EXCHANGE_STORE_NAME = `exchange`;

export interface IExchangeStore extends Partial<Record<Exchange, IMarketSummary | undefined>> {}

export const defaultExchangeStore: IExchangeStore = {};

export const createExchangeStore = (initialState: IExchangeStore) =>
  createSlice({
    name: EXCHANGE_STORE_NAME,
    initialState,
    reducers: {
      storeReset: () => defaultExchangeStore,

      exchangeDataUpdated: (store, action: PayloadAction<{ key: Exchange; response?: IMarketSummary }>) => {
        if (action.payload.response) {
          store[action.payload.key] = action.payload.response;
        } else {
          delete store[action.payload.key];
        }
      }
    }
  });

export const { actions, reducer } = createExchangeStore(defaultExchangeStore);

export const createStore = (initialStore: IExchangeStore = defaultExchangeStore) => {
  const exchangeStore = createExchangeStore(initialStore);
  return configureStore({ reducer: { [EXCHANGE_STORE_NAME]: exchangeStore.reducer } });
};

export const ExchangeStore = createStore();
export type IStore = ReturnType<typeof ExchangeStore.getState>;
